import { CmsValue } from 'core/type/BootstrapConfig.types';
import { PlaceType } from 'core/type/Places.types';
import { SuggestionResult } from 'core/type/SuggestionResult.types';
import { TextSearchType } from 'core/type/TextSearch.types';
import { StringFormatter } from '@agoda/react-handyman';
import { getCategoryName } from 'core/utils/categoryUtils';

export const getLocationTitle = (placeType: PlaceType, cms: CmsValue): string => {
    switch (placeType) {
        // TODO: Enrich cases when we're capable of returning others place type from NPC
        // Agoda.NonPropertyContentApi.Client.Definition
        case PlaceType.City:
            return cms[126802];
        default:
            return '';
    }
};

export const getUpdatedTypeDetail = (suggestion: SuggestionResult, cms: CmsValue): string => {
    switch (suggestion.type) {
        case TextSearchType.City: {
            const countryName = suggestion.countryName || suggestion.countryNameTranslated;
            return countryName;
        }
        case TextSearchType.Activity: {
            const cityName = suggestion.cityName || suggestion.cityNameTranslated;
            const categoryName = getCategoryName(suggestion, cms);
            return categoryName ? StringFormatter.format(cms[320129], categoryName, cityName) : cityName;
        }
        default:
            return '';
    }
};

export const getTypeDetail = (suggestion: SuggestionResult, cms: CmsValue): string => {
    switch (suggestion.type) {
        case TextSearchType.City: {
            const countryName = suggestion.countryName || suggestion.countryNameTranslated;
            return StringFormatter.format(cms[239423], countryName);
        }
        case TextSearchType.Activity: {
            const cityName = suggestion.cityName || suggestion.cityNameTranslated;
            const countryName = suggestion.countryName || suggestion.countryNameTranslated;
            return StringFormatter.format(cms[239424], cityName, countryName);
        }
        default:
            return '';
    }
};
